import { useEffect } from "react";
import _ from "lodash";

import PusherManager from "utils/pusher-manager";

import { useSignedUser } from "entities/Auth/sdk";

import { MemoSignatureStatus } from "./components/Sections/MemoESignatureDrawer/constants";

export const useMemoESignProcessFinishedEvent = ({
  eventHandler,
}: {
  eventHandler: ({ status }: { status: MemoSignatureStatus }) => void;
}) => {
  const { data: user } = useSignedUser();

  useEffect(() => {
    if (!_.isUndefined(user) && !_.isNil(eventHandler)) {
      return PusherManager.bindToMemoESignProcessFinishedEvent({
        userId: user.id,
        eventHandler: eventHandler,
      });
    }
  }, [user, eventHandler]);
};

export const useMemoESignProcessStartedOrCancelledEvent = ({
  eventHandler,
}: {
  eventHandler: () => void;
}) => {
  const { data: user } = useSignedUser();

  useEffect(() => {
    if (!_.isUndefined(user) && !_.isNil(eventHandler)) {
      return PusherManager.bindToMemoESignProcessStartedOrCancelledEvent({
        userId: user.id,
        eventHandler: eventHandler,
      });
    }
  }, [user, eventHandler]);
};
